export const getStoredAuthToken = () => {
  // Authentication is server-managed through the HttpOnly authToken cookie.
  return undefined;
};
